export default function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/emoji-mart/dist-es/polyfills/classCallCheck.js
// module id = 136
// module chunks = 2